module.exports = __webpack_public_path__ + "img/active-2.36947a7c.png";